import React, {
    useEffect,
    useState,
    useMemo, useContext, useCallback,
} from 'react';

import PropTypes from 'prop-types';
import axios from "axios";
import AuthContext from "../../AuthContext";
import IndicatorsContext from "./IndicatorsContext";

const IndicatorsContextProvider = ({
                                   children,
                               }) => {

    const [isReady, setIsReady] = useState(null)
    const [affinitiesQuantity, setAffinitiesQuantity] = useState(null)
    const [advisersData, setAadvisersData] = useState(null)
    const [monthlyEmissionsQuantity, setMonthlyEmissionsQuantity] = useState(null)
    const [totalEmissionsQuantity, setTotalEmissionsQuantity] = useState(null)
    const [totalAverageQuota, setTotalAverageQuota] = useState(null)
    const [monthlyAverageQuota, setMonthlyAverageQuota] = useState(null)
    const [monthlyPremium, setMonthlyPremium] = useState(null)
    const [totalEmissionsByAffinity, setTotalEmissionsByAffinity] = useState(null)
    const [totalQuotationsByAffinity, setTotalQuotationsByAffinity] = useState(null)
    const [totalQuotationsQuantity, setTotalQuotationsQuantity] = useState(null)

    const {authToken} = useContext(AuthContext)



    useEffect(() => {
        let shouldUpdate = true;
        //
        const init = async () => {

            let url = process.env.REACT_APP_BACK_SERVER + '/m/getDatosIndicadores'

            axios.post(url, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            }).then((resp) => {
                if (shouldUpdate) {
                    // console.log("DATOS", resp)
                    setAffinitiesQuantity(resp.data['afinidades'])

                    resp.data['data_asesores'].map((asesor, index) => {
                        asesor.conversion_rate = ((asesor.total_emisiones / asesor.total_cotizaciones) *100).toFixed(2)
                    })

                    setAadvisersData(resp.data['data_asesores'])
                    setMonthlyEmissionsQuantity(resp.data['emisiones_mes'])
                    setTotalEmissionsQuantity(resp.data['total_emisiones'])
                    setTotalAverageQuota(resp.data['valor_cuota_promedio'])
                    setMonthlyAverageQuota(resp.data['valor_cuota_promedio_mes'])
                    setMonthlyPremium(resp.data['prima_mes'])
                    setTotalEmissionsByAffinity(resp.data['emisiones_por_afinidad'])
                    setTotalQuotationsByAffinity(resp.data['cotizaciones_por_afinidad'])
                    setTotalQuotationsQuantity(resp.data['total_cotizaciones'])
                    setIsReady(true);
                }

            })

        }

        init();
        return () => {
            /* This cleanup function is used to prevent updating the state
            when the component is unmounted */
            shouldUpdate = false;
        };

    }, [])

    const context = useMemo(() => ({
        affinitiesQuantity,
        advisersData,
        monthlyEmissionsQuantity,
        totalEmissionsQuantity,
        totalAverageQuota,
        monthlyAverageQuota,
        monthlyPremium,
        totalEmissionsByAffinity,
        totalQuotationsByAffinity,
        totalQuotationsQuantity,
        isReady,

    }), [
        affinitiesQuantity,
        advisersData,
        monthlyEmissionsQuantity,
        totalEmissionsQuantity,
        totalAverageQuota,
        monthlyAverageQuota,
        monthlyPremium,
        totalEmissionsByAffinity,
        totalQuotationsByAffinity,
        totalQuotationsQuantity,
        isReady,
    ]);
    return (
        <IndicatorsContext.Provider value={context}>
            {children}
        </IndicatorsContext.Provider>
    );
}
IndicatorsContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default IndicatorsContextProvider;